import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

/**
 * User is identified by a bearer token (Authorization header)
 */
export const IngestMessageRequest = z.object({
  agentId: z.string(),
  chatId: z.string(),
  message: z.string(),
})

export type IngestMessageRequest = z.infer<typeof IngestMessageRequest>

export const IngestMessageResponse = z.record(z.string(), z.never())

export type IngestMessageResponse = z.infer<typeof IngestMessageResponse>

export const ingestMessageDeclaration = endpointDeclaration(IngestMessageRequest, IngestMessageResponse)
